import { User } from '@models/user.model';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { RootState } from '../store';

interface UserState {
  // broker: Farmer | undefined;
  user: User | null;
}

const initialState: UserState = {
  user: null,
  // broker: undefined,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, { payload }: PayloadAction<User | null>) => {
      state.user = payload;
    },

    // setBroker: (state, action: PayloadAction<Farmer | undefined>) => {
    //   state.broker = action.payload;
    // },
  },
});

export const { setUser } = userSlice.actions;

export const selectUser = (state: RootState) => state.user.user;
// export const selectBroker = (state: RootState) => state.user.broker;

export default userSlice.reducer;
